<template>
  <div class="result-game-info">
    <div v-if="data.rank === 1" class="stars"></div>
    <t-card class="content" :class="data.rank != 1 ? 'not-win' : ''">
      <c-result-banner class="banner">
        <div class="text congrats" v-html="rankText"></div>
      </c-result-banner>
      <p class="text" v-html="scoreText"></p>
    </t-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { marked } from 'marked'
import CResultBanner from '@/components/CResultBanner.vue'
import { Ranking } from '@/model/CompetitionResult'
import { useI18n } from 'vue-i18n'
const props = defineProps<{ data: Ranking }>()
const { t } = useI18n()
const scoreText = computed(() => {
  return marked(t('resultView.gameFinished.score', { score: props.data.score }))
})
const rankText = computed(() => {
  return marked(t('resultView.gameFinished.rank', { rank: props.data.rank }))
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../styles/vars';
.result-game-info {
  margin-top: 3em;

  .stars {
    position: relative;
    margin-top: -0.625rem;
    left: 50%;
    transform: translateX(-50%);
    width: 12.125em;
    height: 5.125em;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .content {
    position: relative;
    margin: 0em auto 2em;
    padding: 0 0 1.5em;
    max-width: 34em;
    text-align: center;

    .banner {
      margin-bottom: 1.125em;
    }

    .congrats {
      color: white;
      strong {
        color: @c1-c;
      }
    }

    .text {
      font-size: 1.63em;
      padding: 0.1em 0;
    }
  }

  .not-win {
    margin-top: 4.5em;
  }

  .colorScheme.midGreen & {
    .stars {
      background-image: url('../assets/results/winner_top_skat.png');
    }
    .content {
      box-shadow: inset 0 0 0 1px #d9e2e7, 0 0.3em 0 @colorScheme--midGreen, 0 0 3em rgba(49, 58, 63, 0.1);
    }
  }

  .colorScheme.red & {
    .stars {
      background-image: url('../assets/results/winner_top_romme.png');
    }
    .content {
      box-shadow: inset 0 0 0 1px #d9e2e7, 0 0.3em 0 @colorScheme--red, 0 0 3em rgba(49, 58, 63, 0.1);
    }
  }
}
</style>
